import { Component, HostBinding, Input, ChangeDetectionStrategy } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { HighFivesService } from '@app/api/api-services';
import { BaseModalDirective } from 'src/app/shared/modals';
import { HighFiveApiModel } from '@app/api/api-models';

@Component({
  templateUrl: 'high-five-view-modal.component.html',
  styleUrls: ['high-five-view-modal.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class HighFiveViewModalComponent extends BaseModalDirective {
  @Input()
  public highFive: HighFiveApiModel;

  @Input()
  public id: number;

  @HostBinding('class')
  public modalType = 'grey lg fixed-height';

  public otherSubjectsText: string;

  constructor(bsModalRef: BsModalRef, private readonly highFivesService: HighFivesService) {
    super(bsModalRef);
  }

  protected init(): void {
    if (this.highFive) {
      this.dataLoaded = true;
      this.stringifySubjects();
      return;
    }

    this.load();
  }

  private load(): void {
    const subscription = this.highFivesService.get(this.id).subscribe((response) => {
      this.highFive = response;
      this.dataLoaded = true;
      this.stringifySubjects();
    });

    this.subscriptions.add(subscription);
  }

  private stringifySubjects(): void {
    this.otherSubjectsText = this.highFive.OtherSubjects.map((x) => x.FullName).join('; ');
  }
}
